import axios from "axios";

const GetContractorTerminations = async (employeeId) => {
  return axios
    .get(`ContractorTermination/GetContractorTerminations`, { params: { p_employeeId: employeeId } })
    .then((response) => response);
};

const contractorTerminationService = {
  GetContractorTerminations,
};

export default contractorTerminationService;